module.exports = window.gtag;